module.exports = __webpack_public_path__ + "static/media/HB_SFP_2014_6_14_2014_005.9b017eb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/makeup_hair/HB_SFP_2014_6_14_2014_005.jpg
// module id = 369
// module chunks = 0